import qs from 'qs';
/**
 * @description 运行环境dev/t/pre/pro
 * @returns {String} env
 */
export function getEnv() {
    let envArray = ['t', 'pre'];
    let dev = window.location.hostname.includes('localhost') || window.location.host.split('-')[0] === 'dev' ? 't-' : '';
    let urlHost = window.location.host.split(/\.|-/)[0];
    return dev || (envArray.includes(urlHost) ? urlHost + '-' : '');
}

/**
 * @description 判断是否嵌套在app内还是微信
 * @returns {String} agent
 */
export function getUseragent() {
    let ua = navigator.userAgent;
    if (ua.includes('gaodun')) {
        return 'app';
    } else if (ua.match(/MicroMessenger/i) === 'MicroMessenger') {
        return 'weixin';
    } else {
        return 'browser';
    }
}
/**
 * @description 取得cookie
 * @param {*} name
 * @returns {*} cookie
 */
export function getCookie(name) {
    let nameEQ = name + '=';
    let ca = document.cookie.split(';'); //把cookie分割成组    
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i]; //取得字符串    
        while (c.charAt(0) === ' ') { //判断一下字符串有没有前导空格    
            c = c.substring(1, c.length); //有的话，从第二位开始取    
        }
        if (c.indexOf(nameEQ) === 0) { //如果含有我们要的name    
            return unescape(c.substring(nameEQ.length, c.length)); //解码并截取我们要值    
        }
    }
    return false;
}

/**
 * @description 设置cookie
 * @param {*} name 
 * @param {*} value 
 * @param {*} hours 
 * @param {*} domain
 */
export function setCookie(name, value, hours, domain) {
    hours = hours || 0; //hours有值就直接赋值，没有为0
    let expires = '';
    if (hours !== 0) { //设置cookie生存时间    
        let date = new Date();
        date.setTime(date.getTime() + (hours * 3600 * 1000));
        expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + escape(value) + expires + '; path=/;domain=' + domain; //转码并赋值    
}

/**
 * @description 清除cookie
 * @param {*} name 
 */
export function clearCookie(name) {
    setCookie(name, '', -1);
}

/**
 * @description 手机号验证
 * @param {*} str 
 * @returns {Boolean} status
 */
export function isPhone(str) {
    let reg = /^1[0-9]{10}$/;
    if (reg.test(str)) {
        return true;
    } else {
        return false;
    }
}

/**
 * @description 邮箱验证
 * @param {*} str 
 * @returns {Boolean} status
 */
export function isEmail(str) {
    let reg = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
    if (reg.test(str)) {
        return true;
    } else {
        return false;
    }
}

/**
 * @description 金额数字验证
 * @param {*} str 
 * @returns {Boolean} status
 */
export function isPrice(str) {
    let reg = /^[0-9]+(.[0-9]{1,2})?$/;
    if (reg.test(str)) {
        return true;
    } else {
        return false;
    }
}

/**
 * @description 浮点数加法运算
 * @param {*} arg1 
 * @param {*} arg2 
 * @returns {*} result
 */
export function floatAdd(arg1, arg2) {
    let r1, r2, m;
    try {
        r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m;
}

/**
 * @description 浮点数减法运算
 * @param {*} arg1 
 * @param {*} arg2 
 * @returns {*} result
 */
export function floatSub(arg1, arg2) {
    let r1, r2, m, n;
    try {
        r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    //动态控制精度长度
    n = (r1 >= r2) ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

/**
 * @description json取值 避免undefined报错
 * @param {*} fn 
 * @param {*} defaultValue 
 * @returns {*} 正常值或undefined 
 */
export function getValue(fn, defaultValue) {
    try {
        return fn();
    } catch (error) {
        return defaultValue;
    }
}

/**
 * @description json取值 避免undefined报错
 * @param {*} file 
 * @returns {*} promise 
 */
export function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
/**
 * @description  解析url参数
 * @returns{*} json 
 */
export function parseUrl() {
    let url = window.location.href;
    let result = url.indexOf('?') > -1 ? qs.parse(url.substring(url.indexOf('?') + 1)) : {};
    return result;
}

/**
 * @description 文件下载
 * @param {*} fileUrl 
 * @param {*} fileName
 */
export function downloadFile(fileUrl, fileName) {
    if (window.fetch) {
        fetch(fileUrl)
            .then((res) => res.blob())
            .then((blob) => {
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                let aId = fileName + '_' + +new Date();
                a.id = aId;
                a.href = url;
                a.download = fileName;
                document.body.append(a); //修复qq浏览器无法下载
                a.click();
                setTimeout(() => {
                    document.getElementById(aId) && a.remove(); //修复qq浏览器无法连续下载
                }, 1000);
            });
    } else {
        let a = document.createElement('a');
        a.href = fileUrl;
        a.target = '_blank';
        a.download = fileName;
        a.click();
    }

}

/**
 * @description 获取url参数
 * @param {*} name 
 * @returns {*} string 
 */
export function getUrlParam(name) {
    if (!window.location.href.includes('?')) return '';
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    let r = window.location.href.split('?')[1].match(reg);
    if (r != null) return unescape(r[2]);
    return '';
}

export function getLinkSearch(key) { // 链接上有大写字母请转小写获取
    let pairs = window.location.search.slice(1).split('&') || [];
    let result = {};
    pairs.forEach(function (pair) {
        if (pair && pair.indexOf('=') !== -1) {
            pair = pair.split('=');
            //兼容写法
            let keyData = pair[0].toLocaleLowerCase();
            result[keyData] = decodeURIComponent(pair[1] || '');
        }
    });
    return result[key];
}

/**
 * @description 判断是否测评过来跳转服务列表
 */
const editUrlAddNeed = (url, projectId, teamType, sourcesType, sourcesId) => {
    let resUrl = url;
    // 新类型拼接参数
    if (projectId) {
        resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}projectId=${projectId}`;
    }
    if (teamType) {
        resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}teamType=${teamType}`;
    }
    if (sourcesType) {
        resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}sourcesType=${sourcesType}`;
    }
    if (sourcesId) {
        resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}sourcesId=${sourcesId}`;
    }
    return resUrl;
};


export function isEvaluationjump(goEvaluation) {
    if (sessionStorage.getItem('successInfo')) {
        sessionStorage.removeItem('successInfo');
    }

    const { evaluationReportId, saas_id, chapterId, sectionId, projectId, teamType, sourcesType, sourcesId } = parseUrl();

    if (evaluationReportId) {
        !goEvaluation ?
            window.open(editUrlAddNeed(`/tutor/bookinglist?evaluationReportId=${evaluationReportId}&saas_id=${saas_id}&chapterId=${chapterId}&sectionId=${sectionId}`, projectId, teamType, sourcesType, sourcesId), '_self') :
            window.open(`https://${getEnv()}glivepro.gaodun.com/course/${saas_id}/personal-trainer-booking`, '_self');
        return;
    }
    window.open(editUrlAddNeed('/tutor/bookinglist', projectId, teamType, sourcesType, sourcesId), '_self');
    return;
}

export const TEACHER_HEAD_IMG = 'https://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202112/02/559c4_20211202092421.jpg';


